/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Directive } from '@angular/core';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';

/**
 * This is a temporarily solution until we decide
 * whether we will use always floated labels in the whole application or will not.
 * Alternative is <code>MAT_LABEL_GLOBAL_OPTIONS</code> on the root module.
 */
@Directive({
  standalone: false,
  selector: '[ghFloatLabelAlways]',
  providers: [{ provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { float: 'always' } }],
})
export class FloatLabelAlwaysDirective {
}
